// extracted by mini-css-extract-plugin
module.exports = {"foundContainer":"Block_foundContainer__2s3rC","foundIcon":"Block_foundIcon__1x9C8","foundText":"Block_foundText__1OCfv"};